import { ISocialGraph } from '@nocode/types';
import { View } from 'react-native';
import React from 'react';
import queryString from 'query-string';
import SocialNetworkGraph from './SocialNetworkGraph';
import { allAmountsZero, mapConnections, useStaticNodes } from './hook';
import { mapPropColor } from '@common/utils/color';

const SocialGraph: React.FC<ISocialGraph> = (props) => {
  const { height, dataBinding, width, attributes, style } = props;
  const { hasIcon, node, amountDisplay, amount } = mapPropColor(attributes);
  const { backgroundColor, color: textColor, opacity } = style;
  const { activeColor, color } = node?.styles ?? {};
  const search = queryString.parse(window?.location?.search);
  const isCanvas = !search?.target;
  if (isCanvas) {
    const { formula } = amount?.amount || [];
    const isZeroAmount = !(formula?.length >= 2);
    return (
      <View style={{ opacity: opacity }}>
        <SocialNetworkGraph
          nodes={useStaticNodes()}
          width={width}
          height={height}
          showLabels={true}
          directional={true}
          showArrows={false}
          arrowSize={6}
          iconName={hasIcon && hasIcon.enabled ? hasIcon.iconName : ''}
          nodeColor={color == '@primaryColor' ? undefined : color}
          textColor={textColor}
          backgroundColor={backgroundColor}
          highlightedNodeColor={activeColor}
          showAmounts={amountDisplay && amountDisplay.enabled}
          isZeroAmounts={isZeroAmount}
        />
      </View>
    );
  } else {
    if (dataBinding?.length) {
      const dataRes = mapConnections(dataBinding as any[]);
      const isZeroAmounts = allAmountsZero(dataRes);
      return (
        <View>
          <SocialNetworkGraph
            nodes={dataRes}
            width={width}
            height={height}
            showLabels={true}
            directional={true}
            showArrows={false}
            arrowSize={6}
            iconName={hasIcon && hasIcon.enabled ? hasIcon.iconName : ''}
            nodeColor={color == '@primaryColor' ? undefined : color}
            highlightedNodeColor={activeColor}
            onNodePress={(nodeId) => {}}
            textColor={textColor}
            showAmounts={amountDisplay && amountDisplay.enabled}
            backgroundColor={backgroundColor}
            isZeroAmounts={isZeroAmounts}
          />
        </View>
      );
    } else {
      return <View></View>;
    }
  }
};

export default SocialGraph;
